import type { EntityPanelProps } from './entity-panel.interface';

import classNames from 'classnames';
import { memo, useState } from 'react';

export const EntityPanel = memo(
  ({
    title = 'Unnamed entity',
    className,
    onDelete,
    isDeletable,
    isSelectable,
    isSmall,
    isDisabled,
    onClick,
    isFixed,
  }: EntityPanelProps) => {
    const [selected, setSelected] = useState(false);

    const handleClick = () => {
      if (isSelectable) {
        setSelected((prev) => !prev);
      }
      if (onClick) {
        onClick();
      }
    };

    const handleDeleteClick = (event: React.MouseEvent<HTMLElement>) => {
      event.stopPropagation();
      if (onDelete) {
        onDelete(event);
      }
    };

    const containerClasses = classNames(
      'entities-item',
      {
        deletable: isDeletable,
        small: isSmall,
        disabled: isDisabled,
        selected,
        hoverable: isSelectable || !!onClick,
        fixed: isFixed,
      },
      className,
    );

    return (
      <div className={containerClasses} onClick={handleClick}>
        <div className="entities-item-content">
          <p className="entities-item__title">{title}</p>
          {isDeletable && onDelete && (
            <i className="entities-item__delete" onClick={handleDeleteClick} />
          )}
        </div>
      </div>
    );
  },
);

EntityPanel.displayName = 'EntityPanel';
